module.exports = __webpack_public_path__ + "static/media/game-circle.4255d71d.png";